var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M657 637L657 665",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 657.5,
    cy: 632.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M654.105 641C653.637 641 653.236 640.834 652.903 640.501C652.57 640.168 652.403 639.768 652.403 639.3C652.403 638.833 652.57 638.432 652.903 638.099C653.236 637.766 653.637 637.6 654.105 637.6C654.573 637.6 654.973 637.766 655.306 638.099C655.64 638.432 655.806 638.833 655.806 639.3C655.806 639.768 655.64 640.168 655.306 640.501C654.973 640.834 654.573 641 654.105 641ZM662.613 641C662.145 641 661.744 640.834 661.411 640.501C661.078 640.168 660.911 639.768 660.911 639.3C660.911 638.833 661.078 638.432 661.411 638.099C661.744 637.766 662.145 637.6 662.613 637.6C663.081 637.6 663.481 637.766 663.814 638.099C664.148 638.432 664.314 638.833 664.314 639.3C664.314 639.768 664.148 640.168 663.814 640.501C663.481 640.834 663.081 641 662.613 641ZM653.382 627.4L655.423 631.65H661.379L663.719 627.4H653.382ZM652.573 625.7H665.122C665.449 625.7 665.697 625.845 665.867 626.136C666.037 626.426 666.044 626.72 665.888 627.018L662.868 632.457C662.712 632.741 662.503 632.96 662.24 633.116C661.978 633.272 661.691 633.35 661.379 633.35H655.041L654.105 635.05H664.314V636.75H654.105C653.467 636.75 652.985 636.47 652.658 635.911C652.332 635.351 652.318 634.795 652.616 634.242L653.764 632.16L650.702 625.7H649V624H651.765L652.573 625.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.a40722023de728b2cf3c3ce9480f2fb0.svg";
export { ForwardRef as ReactComponent };